import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// store
import { useStoreValue, storeSet } from '../../store';

// components
import AppTopbar from './components/AppTopbar';
import { Toaster } from 'sonner';

const DefaultLayout = ({ children }) => {
    const isError404 = useStoreValue('isError404');
    const location = useLocation();

    useEffect(() => {
        storeSet('isError404', false);
    }, [location]);

    return (
        <main className="wrapper">
            {isError404
                ? <p>Error 404</p>
                : <>
                    <AppTopbar/>
                    {children}
                </>}
            <Toaster/>
        </main>
    )
}

export default DefaultLayout;